import React from 'react';
import PropTypes from 'prop-types';
import { IconChevronLeft } from 'components/Icons';

const BackButton = ({ returnUrl }) => {
  return (
    <div className="syos-back-button">
      {returnUrl && (
        <a href={returnUrl} className="syos-button syos-button--back">
          <IconChevronLeft /> Back
        </a>
      )}
    </div>
  );
};
BackButton.propTypes = {
  returnUrl: PropTypes.string
};

export default BackButton;



// WEBPACK FOOTER //
// ./src/javascripts/components/BackButton.js